
<template>
  <div class="animated fadeIn">
    <b-row class="my-5">
      <b-col>
        <h4 class="text-center text-primary">
          <i class="fa fa-check-square text-primary mr-2"></i>
          Nueva Lista de Distribución
        </h4>
      </b-col>
    </b-row>
    <b-row>
      <b-card class="w-100 mx-auto shadow-sm mt-5">
        <div class="container-fluid w-100 px-0">
          <b-form @submit.prevent="store" class="w-100" enctype="multipart/form-data">
            <b-row class="mx-0 py-4">
              <b-col lg="12" md="12">
                <b-row class="py-4 mt-2 border" v-for="(field, i) in search_fields" :key="i">
                  <template class="mt-2" v-for="(item, k) in field.rows">
                    <!-- 1st campo field -->
                    <b-col lg="3" md="3" class="mb-3" :class="(selectedChildEntity == item.field.fieldName) ? 'hasChildEntity' : '' ">
                      <b-form-group
                        label="<strong>Campo *</strong>"
                        :horizontal="false"
                        label-for="status"
                        class="mb-0">

                        <b-form-select :class="['form-control', {'is-invalid': errors.has(`field${k}`)}]"
                                       v-validate="'required'" :name="`field${k}`" :state="validateState(`field${k}`)"
                                       v-model="item.field"
                                       @change="searchFieldConditions($event)"
                                       :data-index="k"
                                       :data-value="item.field"
                                       :disabled="selectedChildEntity == item.field.fieldName"
                        >
                          <option value=""></option>
                          <option v-for="field in item.fields"
                                  v-bind:value="{fieldType: field.field.type, fieldName: field.field.name, row: field.field.value, parent: i, index: k, fieldDataAttr: field.field.fieldEntityType}" :selected="selectedCampoEntity[k] == item.field">
                            {{ field.field.name.charAt(0).toUpperCase() + field.field.name.slice(1).toLowerCase() }}
                          </option>

                        </b-form-select>
                        <div v-show="errors.has(`field${k}`)" class="invalid-feedback">
                          {{ errors.first(`field${k}`) }}
                        </div>
                      </b-form-group>
                    </b-col>

                    <b-col lg="3" md="3" class="mb-3" :class="(item.field.fieldDataAttr) ? '' : 'd-none'">
                      <b-form-group
                        label="<strong>Campo *</strong>"
                        :horizontal="false"
                        label-for="status"
                        class="mb-0">
                        <b-form-select :class="['form-control', {'is-invalid': errors.has(`field${k}`)}]"
                                       v-validate="'required'" :name="`field${k}`" :state="validateState(`field${k}`)"
                                       v-model="item.childField"
                                       @change="searchFieldConditions($event)">

                          <option value="" selected></option>
                          <option v-for="field in item.childFields"
                                  v-bind:value="{fieldType: field.field.type, fieldName: field.field.name, row: field.field.value, parent: i, index: k, fieldDataAttr: field.field.fieldEntityType}">
                            {{ field.field.name.charAt(0).toUpperCase() + field.field.name.slice(1).toLowerCase() }}
                          </option>
                        </b-form-select>
                        <div v-show="errors.has(`field${k}`)" class="invalid-feedback">
                          {{ errors.first(`field${k}`) }}
                        </div>
                      </b-form-group>
                    </b-col>

                    <b-col lg="3" md="3" class="mb-3" :class="(item.field.fieldDataAttr && item.field.fieldType === 'DROPDOWN' && item.childField.fieldType === 'DROPDOWN') || (!item.field.fieldDataAttr && item.field.fieldType === 'DROPDOWN') ? 'd-none' : 'd-block'">
                      <b-form-group
                        label="<strong>Condición *</strong>"
                        :horizontal="false"
                        label-for="status"
                        class="mb-0">

                        <b-form-select :class="['form-control', {'is-invalid': errors.has(`fieldCondition${k}`)}]"
                                       v-validate="'required'" :name="`fieldCondition${k}`"
                                       v-model="item.fieldCondition" >
                          <option value="" selected></option>
                          <option v-for="fieldCondition in item.fieldConditions" :value="fieldCondition.filter">
                            {{ fieldCondition.filter.charAt(0).toUpperCase() + fieldCondition.filter.slice(1).toLowerCase() }}
                          </option>
                        </b-form-select>
                        <div v-show="errors.has(`fieldCondition${k}`)" class="invalid-feedback">
                          {{ errors.first(`fieldCondition${k}`) }}
                        </div>
                      </b-form-group>
                    </b-col>

                    <template v-if="item.fieldCondition !== 'nulo' && item.fieldCondition !== 'no nulo'">
                      <b-col  :lg="item.field.fieldType === 'DROPDOWN' ? '6' : '3'" :md="item.field.fieldType === 'DROPDOWN' ? '6' : '3'" class="pt-1 mb-3" v-if="(item.field.row === 'headquarters' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'headquarters' && item.childField.fieldType === 'DROPDOWN')">
                        <headquarters-selector class="mt-4" id="headquarters" v-model="item.text1"></headquarters-selector>
                      </b-col>
                      <b-col  :lg="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" :md="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" class="pt-1 mb-3" v-if="(item.field.row === 'feeType' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'feeType' && item.childField.fieldType === 'DROPDOWN')">
                        <multiselect
                          id="feeType"
                          v-model="item.text1"
                          :options="activeFeeTypes"
                          track-by="key"
                          label="value"
                          :multiple="true"
                          :allowEmpty="true"
                          placeholder="Seleccione"
                          selectLabel="+"
                          deselectLabel="-">
                        </multiselect>
                      </b-col>
                      <b-col  :lg="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" :md="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" class="mt-4 pt-1 mb-3" v-if="(item.field.row === 'active' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'active' && item.childField.fieldType === 'DROPDOWN')">
                        <multiselect
                          id="status"
                          v-model="item.text1"
                          :options="memberStatusOptions"
                          track-by="key"
                          label="value"
                          :allowEmpty="true"
                          placeholder="Seleccione"
                          selectLabel="+"
                          deselectLabel="-">
                        </multiselect>
                      </b-col>
                      <b-col  :lg="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" :md="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" class="mt-4 pt-1 mb-3" v-if="(item.field.row === 'located' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'located' && item.childField.fieldType === 'DROPDOWN')">
                        <multiselect
                          id="situation"
                          v-model="item.text1"
                          :options="memberLocatedOptions"
                          track-by="key"
                          label="value"
                          :allowEmpty="true"
                          placeholder="Seleccione"
                          selectLabel="+"
                          deselectLabel="-">
                        </multiselect>
                      </b-col>
                      <b-col  :lg="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" :md="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" class="mt-4 pt-1 mb-3" v-if="(item.field.row === 'sex' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'sex' && item.childField.fieldType === 'DROPDOWN')">
                        <multiselect
                          :allowEmpty="false"
                          :custom-label="opt => sex.find(x => x.uuid == opt).name"
                          :options="sex.map(type => type.uuid)"
                          deselectLabel="-"
                          name="sex"
                          placeholder="Seleccione"
                          selectLabel="+"
                          v-model="item.text1">
                        </multiselect>
                      </b-col>
                      <b-col  :lg="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" :md="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" class="mt-4 pt-1 mb-3" v-if="(item.field.row === 'businessManager' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'businessManager' && item.childField.fieldType === 'DROPDOWN')">
                        <multiselect
                          name="businessManager"
                          v-model="item.text1"
                          :options="filterActiveStatusUsers(users, 'COMERCIAL')"
                          track-by="uuid"
                          :custom-label="customLabel"
                          :multiple="true"
                          :allowEmpty="true"
                          placeholder="Seleccione"
                          selectLabel="+"
                          deselectLabel="-"
                          v-if="users"
                          autocomplete="off">
                          <template slot="singleLabel" slot-scope="props">
                            {{ props.option.firstname }} {{ props.option.lastname }}
                          </template>
                          <template slot="option" slot-scope="props">
                            <small>{{ props.option.firstname }} {{ props.option.lastname }}</small>
                            <pre v-if="props.option.department">{{ props.option.department.description}}</pre>
                          </template>
                        </multiselect>
                      </b-col>
                      <b-col  :lg="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" :md="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" class="mt-4 pt-1 mb-3" v-if="(item.field.row === 'affiliationManager' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'affiliationManager' && item.childField.fieldType === 'DROPDOWN')">
                        <multiselect
                          name="affiliationManager"
                          v-model="item.text1"
                          :options="filterUsers(users, 'GESTION SOCIOS')"
                          track-by="uuid"
                          :custom-label="customLabel"
                          :multiple="true"
                          :allowEmpty="true"
                          placeholder="Seleccione"
                          selectLabel="+"
                          deselectLabel="-"
                          v-if="users"
                          autocomplete="off">
                          <template slot="singleLabel" slot-scope="props">
                            {{ props.option.firstname }} {{ props.option.lastname }}
                          </template>
                          <template slot="option" slot-scope="props">
                            <small>{{ props.option.firstname }} {{ props.option.lastname }}</small>
                            <pre v-if="props.option.department">{{ props.option.department.description}}</pre>
                          </template>
                        </multiselect>
                      </b-col>
                      <b-col  :lg="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" :md="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" class="mt-4 pt-1 mb-3" v-if="(item.field.row === 'returnManager' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'returnManager' && item.childField.fieldType === 'DROPDOWN')">
                        <multiselect
                          name="returnManager"
                          v-model="item.text1"
                          :options="filterUsers(users, 'ADMINISTRACION')"
                          track-by="uuid"
                          :custom-label="customLabel"
                          :multiple="true"
                          :allowEmpty="true"
                          placeholder="Seleccione"
                          selectLabel="+"
                          deselectLabel="-"
                          v-if="users"
                          autocomplete="off">
                          <template slot="singleLabel" slot-scope="props">
                            {{ props.option.firstname }} {{ props.option.lastname }}
                          </template>
                          <template slot="option" slot-scope="props">
                            <small>{{ props.option.firstname }} {{ props.option.lastname }}</small>
                            <pre v-if="props.option.department">{{ props.option.department.description}}</pre>
                          </template>
                        </multiselect>
                      </b-col>
                      <b-col :lg="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" :md="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" class="mt-4 pt-1 mb-3" v-if="(item.field.row === 'agreement' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'agreement' && item.childField.fieldType === 'DROPDOWN')">
                        <common-agreement-selector id="agreement"
                                                   v-model="item.text1"></common-agreement-selector>
                      </b-col>
                      <b-col  :lg="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" :md="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" class="mt-4 pt-1 mb-3" v-if="(item.field.row === 'paymentMethod' || item.field.row === 'paymentMethods' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'paymentMethod' || item.childField.row === 'paymentMethods' && item.childField.fieldType === 'DROPDOWN')">
                        <multiselect
                          id="paymentMethod"
                          v-model="item.text1"
                          :options="paymentMethodsOptions"
                          track-by="key"
                          label="value"
                          :multiple="true"
                          :allowEmpty="true"
                          placeholder="Seleccione"
                          selectLabel="+"
                          deselectLabel="-">

                        </multiselect>
                      </b-col>
                      <b-col  :lg="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" :md="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" class="mt-4 pt-1 mb-3" v-if="(item.field.row === 'cnaes' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'cnaes' && item.childField.fieldType === 'DROPDOWN')">
                        <cnae-selector v-model="item.text1" :allowEmpty="true"></cnae-selector>
                      </b-col>
                      <b-col  :lg="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" :md="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" class="mt-4 pt-1 mb-3" v-if="(item.field.row === 'origin' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'origin' && item.childField.fieldType === 'DROPDOWN')">
                        <multiselect
                          id="origin"
                          v-model="item.text1"
                          :options="queryOrigins.map(origin => origin.value)"
                          :custom-label="opt => queryOrigins.find(origin => origin.value === opt).text"
                          :multiple="true"
                          :allowEmpty="false"
                          placeholder="Seleccione opción"
                          selectLabel="+"
                          deselectLabel="-"
                        ></multiselect>
                      </b-col>
                      <b-col  :lg="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" :md="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" class="mt-4 pt-1 mb-3" v-if="(item.field.row === 'category' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'category' && item.childField.fieldType === 'DROPDOWN')">
                        <multiselect
                          v-model="item.text1"
                          :options="categories"
                          :custom-label="categoriesCustom"
                          track-by="uuid"
                          :multiple="true"
                          :allowEmpty="false"
                          placeholder="Categoría"
                          selectLabel="+"
                          deselectLabel="-">
                          <template slot="singleLabel" slot-scope="props">
                            {{ props.option.name }}
                          </template>
                          <template slot="option" slot-scope="props">
                            <template
                              v-if="!!props.option.depth && props.option.depth>0"
                              v-for="n in props.option.depth">-
                            </template>
                            {{ props.option.name }}
                          </template>
                        </multiselect>
                      </b-col>
                      <b-col  :lg="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" :md="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" class="mt-4 pt-1 mb-3" v-if="(item.field.row === 'associatedProjects' || item.field.row === 'memberAssociatedProjects' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'associatedProjects' || item.childField.row === 'memberAssociatedProjects' && item.childField.fieldType === 'DROPDOWN')">
                        <multiselect
                          v-model="item.text1"
                          :options="associatedProjects"
                          track-by="uuid"
                          :customLabel="(adviser) => (`${adviser.name}`)"
                          :multiple="true"
                          :allowEmpty="true"
                          placeholder="Asesor"
                          selectLabel="+"
                          deselectLabel="-">
                        </multiselect>
                      </b-col>
                      <b-col  :lg="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" :md="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" class="mt-4 pt-1 mb-3" v-if="(item.field.row === 'adviser' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'adviser' && item.childField.fieldType === 'DROPDOWN')">
                        <multiselect
                          v-model="item.text1"
                          :options="advisers"
                          track-by="uuid"
                          :customLabel="(adviser) => (`${adviser.firstname} ${adviser.lastname}`)"
                          :multiple="true"
                          :allowEmpty="true"
                          placeholder="Asesor"
                          selectLabel="+"
                          deselectLabel="-">
                        </multiselect>
                      </b-col>
                      <b-col  :lg="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" :md="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" class="mt-4 pt-1 mb-3" :class="item.field.fieldDataAttr ? 'd-none' : ''" v-if="(item.field.row === 'client' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'client' && item.childField.fieldType === 'DROPDOWN')">
                        <div>
                          <multiselect
                            id="client"
                            v-model="item.text1"
                            :options="items"
                            :show-after-list="true"
                            :close-on-select="false"
                            track-by="uuid"
                            :custom-label="customClientLabel"
                            :multiple="true"
                            :allowEmpty="true"
                            ref="multiselect"
                            placeholder="Seleccione"
                            selectLabel="+"
                            deselectLabel="-">
                            <template slot="afterList">
                              <div class="multiselect-footer text-center">
                                <loading size="small" v-if="loading"></loading>
                                <button v-if="!loading" type='button' class="btn btn-link pl-0"
                                        @click="fetchData('clients')">Load More
                                </button>
                              </div>
                            </template>
                          </multiselect>
                        </div>
                      </b-col>
                      <b-col  :lg="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" :md="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" class="mt-4 pt-1 mb-3" :class="item.field.fieldDataAttr ? 'd-none' : ''" v-if="(item.field.row === 'member' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'member' && item.childField.fieldType === 'DROPDOWN')">
                        <multiselect
                          id="member"
                          v-model="item.text1"
                          :options="items"
                          :show-after-list="true"
                          :close-on-select="false"
                          track-by="uuid"
                          :custom-label="customClientLabel"
                          :multiple="true"
                          :allowEmpty="true"
                          ref="multiselect"
                          placeholder="Seleccione"
                          selectLabel="+"
                          deselectLabel="-">
                          <template slot="afterList">
                            <div class="multiselect-footer text-center">
                              <loading size="small" v-if="loading"></loading>
                              <button v-if="!loading" type='button' class="btn btn-link pl-0"
                                      @click="fetchData('members')">Load More
                              </button>
                            </div>
                          </template>
                        </multiselect>
                      </b-col>

                      <b-col  :lg="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" :md="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" class="mt-4 pt-1 mb-3" v-if="(item.field.row === 'type' || item.field.row === 'types' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'type' || item.childField.row === 'types' && item.childField.fieldType === 'DROPDOWN')">
                        <consignment-type-selector
                          id="type"
                          v-model="item.text1"></consignment-type-selector>
                      </b-col>
                      <b-col  :lg="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" :md="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" class="mt-4 pt-1 mb-3" v-if="(item.field.row === 'periodicities' || item.field.row === 'periodicity' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'periodicities' || item.childField.row === 'periodicity' && item.childField.fieldType === 'DROPDOWN')">
                        <multiselect
                          id="periodicity"
                          v-model="item.text1"
                          :options="periodicityArray"
                          track-by="key"
                          label="value"
                          :multiple="true"
                          :allowEmpty="true"
                          placeholder="Seleccione"
                          selectLabel="+"
                          deselectLabel="-">

                        </multiselect>
                      </b-col>
                      <b-col  :lg="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" :md="(item.field.fieldType === 'DROPDOWN') ? '6' : '3'" class="mt-4 pt-1 mb-3" :class="item.field.fieldDataAttr ? 'd-none' : ''" v-if="(item.field.row === 'consignment' && item.field.fieldType === 'DROPDOWN') || (item.childField.row === 'consignment' && item.childField.fieldType === 'DROPDOWN')">
                        <multiselect
                          id="consignment"
                          v-model="item.text1"
                          :options="items"
                          :show-after-list="true"
                          :close-on-select="false"
                          track-by="uuid"
                          :customLabel="(consignment) => (`${consignment.code}`)"
                          :multiple="true"
                          :allowEmpty="true"
                          ref="multiselect"
                          placeholder="Seleccione"
                          selectLabel="+"
                          deselectLabel="-">
                          <template slot="afterList">
                            <div class="multiselect-footer text-center">
                              <loading size="small" v-if="loading"></loading>
                              <button v-if="!loading" type='button' class="btn btn-link pl-0"
                                      @click="fetchData('consignments')">Load More
                              </button>
                            </div>
                          </template>
                        </multiselect>
                      </b-col>
                      <b-col lg="3" md="3" class="mb-3" v-if="(item.field.fieldType === 'TEXT') || (item.childField.fieldType === 'TEXT')">
                        <label></label>
                        <b-form-input :class="['mt-2 form-control', {'is-invalid': errors.has(`text1${k}`)}]"
                                      type="text" v-validate="'required'" :name="`text1${k}`"
                                      :placeholder="item.fieldCondition" v-model="item.text1"/>
                        <div v-show="errors.has(`text1${k}`)" class="invalid-feedback">
                          {{ errors.first(`text1${k}`) }}
                        </div>
                      </b-col>
                      <b-col lg="3" md="3" class="mb-3" v-if="(item.field.fieldType === 'NUMBER') || (item.childField.fieldType === 'NUMBER')">
                        <template v-if="[ 'entre ios valores', 'no entre ios valores'].includes(item.fieldCondition)">

                          <b-form-input type="number"
                                        :class="['mt-2 w-50 form-control', {'is-invalid': errors.has(`text1${k}`)}]"
                                        v-validate="'required'" :name="`text1${k}`" placeholder="menor"
                                        v-model="item.text1"/>
                          <div v-show="errors.has(`text1${k}`)" class="invalid-feedback">
                            {{ errors.first(`text1${k}`) }}
                          </div>

                          <label></label>
                          <b-form-input type="number"
                                        :class="['mt-2 w-50 form-control', {'is-invalid': errors.has(`text2${k}`)}]"
                                        v-validate="'required'" :name="`text2${k}`" placeholder="mayor"
                                        v-model="item.text2"/>
                          <div v-show="errors.has(`text2${k}`)" class="invalid-feedback">
                            {{ errors.first(`text2${k}`) }}
                          </div>

                        </template>
                        <template v-else>
                          <label></label>
                          <b-form-input :class="['mt-2 form-control', {'is-invalid': errors.has(`text1${k}`)}]"
                                        type="number" v-validate="'required'" :name="`text1${k}`"
                                        :placeholder="item.fieldCondition" v-model="item.text1"/>
                          <div v-show="errors.has(`text1${k}`)" class="invalid-feedback">
                            {{ errors.first(`text1${k}`) }}
                          </div>
                        </template>
                      </b-col>
                      <b-col lg="3" md="3" class="mb-3" style="display: flex" v-if="(item.field.fieldType === 'DATE') || (item.childField.fieldType === 'DATE')">
                        <template v-if="[ 'entre ios valores', 'no entre ios valores'].includes(item.fieldCondition)">

                          <b-form-group
                            :horizontal="true"
                            class="w-50 text-right mt-4 pt-1 mb-0"
                            label=""
                            label-cols="1"
                            label-for="partnerBirthdate">
                            <v-date-picker v-model="item.text1" :max-date="new Date()" popoverDirection="top">
                              <template v-slot="{ inputValue, inputEvents }">
                                <b-form-input
                                  :value="inputValue"
                                  v-on="inputEvents"
                                  :id="`text1${k}`"
                                  :name="`text1${k}`"
                                  :class="['form-control', {'is-invalid': errors.has(`text1${k}`)}]"
                                  v-validate="'required'"
                                  :state="validateState('partnerBirthdate')"
                                  aria-describedby="check_partnerBirthdate"/>
                              </template>
                            </v-date-picker>
                          </b-form-group>
                          <div v-show="errors.has(`text1${k}`)" class="invalid-feedback">
                            {{ errors.first(`text1${k}`) }}
                          </div>

                          <b-form-group
                            :horizontal="true"
                            class="w-50 text-right mt-4 pt-1 mb-0"
                            label=""
                            label-cols="1"
                            label-for="partnerBirthdate">
                            <v-date-picker v-model="item.text2" :max-date="new Date()" popoverDirection="top">
                              <template v-slot="{ inputValue, inputEvents }">
                                <b-form-input
                                  :value="inputValue"
                                  v-on="inputEvents"
                                  :id="`text2${k}`"
                                  :name="`text2${k}`"
                                  :class="['form-control', {'is-invalid': errors.has(`text2${k}`)}]"
                                  v-validate="'required'"
                                  :state="validateState('partnerBirthdate')"
                                  aria-describedby="check_partnerBirthdate"/>
                              </template>
                            </v-date-picker>
                          </b-form-group>
                          <div v-show="errors.has(`text2${k}`)" class="invalid-feedback">
                            {{ errors.first(`text2${k}`) }}
                          </div>

                        </template>
                        <template v-else>
                          <b-form-group
                            :horizontal="true"
                            class="w-100 text-right mt-4 pt-1 mb-0"
                            label=""
                            label-cols="1"
                            label-for="partnerBirthdate">
                            <v-date-picker v-model="item.text1" :max-date="new Date()" popoverDirection="top">
                              <template v-slot="{ inputValue, inputEvents }">
                                <b-form-input
                                  :value="inputValue"
                                  v-on="inputEvents"
                                  :id="`text1${k}`"
                                  :name="`text1${k}`"
                                  :class="['form-control', {'is-invalid': errors.has(`text1${k}`)}]"
                                  v-validate="'required'"
                                  :state="validateState('partnerBirthdate')"
                                  aria-describedby="check_partnerBirthdate"/>
                              </template>
                            </v-date-picker>
                          </b-form-group>
                          <div v-show="errors.has(`text1${k}`)" class="invalid-feedback">
                            {{ errors.first(`text1${k}`) }}
                          </div>
                        </template>
                      </b-col>
                      <b-col lg="3" md="3" class="mt-4 pt-1 mb-3" v-if="(item.field.fieldType === 'BOOLEAN') || (item.childField.fieldType === 'BOOLEAN')">
                        <b-form-select v-model="item.text1" :class="['form-control', {'is-invalid': errors.has(`fieldCondition${k}`)}]" v-validate="'required'" >
                          <option value=""></option>
                          <option value="Yes">Sí</option>
                          <option value="No">No</option>
                        </b-form-select>
                      </b-col>
                    </template>

                    <template v-if="(!!item.field || !!item.fieldCondition) && (!!item.text1 || !!item.text2)">
                      <b-col lg="3" md="3">
                        <b-button
                          :variant="item.sqlConditions === 'AND' ? 'primary' : 'outline'"
                          v-bind:class="[item.sqlConditions === 'AND' ? 'rounded-circle mt-4 btn-primary' : 'rounded-circle bg-white btn-outline mt-4']"
                          @click="addGroupCondition('AND', i, k)">Y
                        </b-button>
                        <b-button
                          :variant="item.sqlConditions === 'OR' ? 'primary' : 'outline'"
                          v-bind:class="[item.sqlConditions === 'OR' ? 'rounded-circle mt-4 ml-2 btn-primary' : 'rounded-circle bg-white btn-outline mt-4 ml-2']"
                          @click="addGroupCondition('OR', i, k)">O
                        </b-button>
                        <b-button
                          class="rounded-circle mt-4 ml-2 btn-primary"
                          @click="deleteGroupCondition(i, k)"><i class="fa fa-remove"></i>
                        </b-button>
                      </b-col>
                    </template>
                  </template>

                </b-row>
              </b-col>

              <b-col lg="12" md="12" class="pt-lg-4 pl-0">
                <button type='button' class="btn btn-link pl-0" @click="addNewRow">
                  <i class="fa fa-plus"></i>
                  Añadir grupo de condiciones
                </button>
              </b-col>

            </b-row>

            <b-row class="pt-3">
              <div class="col float-left">
                <button :disabled="!validate()"
                        class="btn btn-brand btn-primary btn-lg pull-right"
                        type="submit">
                  Guardar
                </button>
              </div>
            </b-row>
          </b-form>
        </div>
      </b-card>
    </b-row>
    <hr>
  </div>
</template>

<script>
import {request, parseRequest} from '@/helpers/services';
import Multiselect from 'vue-multiselect';
import {setupCalendar, DatePicker} from 'v-calendar';
import {mapGetters} from 'vuex';
import form from '@/helpers/form';
import moment from 'moment';
import {filterUsers, filterActiveStatusUsers} from '@/helpers/user-helper';
import {getQueryOriginsOptions} from '@/helpers/query-helper';
import {searchFields, searchFieldConditions} from '@/api/search-api';
import {getAdvisers} from '@/api/user-api';
import {getQueryCategoriesTree} from '@/api/query-category-api';
import {getAssociatedProjects} from '@/api/associated-project-api';
import {memberStatusOptions, memberLocatedOptions} from '@/constants/client-constants';
import {periodicityOptions} from '@/constants/fee-type-constants';
import {paymentMethods} from '@/constants/payment-constants';
import headquartersSelector from '@/components/headquarters/HeadquartersSelector';
import feeAgreementSelector from '@/components/agreements/FeeAgreementSelector';
import FeeTypeMultipleSelector from '@/components/fee-types/FeeTypeMultipleSelector';
import commonAgreementSelector from '@/components/agreements/CommonAgreementSelector';
import PaymentMethodMultipleSelector from '@/components/clients/members/PaymentMethodMultipleSelector';
import consignmentTypeSelector from '@/components/consignments/ConsignmentTypeSelector';
import periodicityMonthsMultipleSelector from '@/components/periodicity/PeriodicityMonthsMultipleSelector';
import CnaeSelector from '@/components/clients/cnaes/CnaeSelector';
import InfiniteLoading from 'vue-infinite-loading';
import vSelect from 'vue-select';
import 'v-calendar/lib/v-calendar.min.css';

setupCalendar({
  firstDayOfWeek: 2,
});

export default {
  name: 'searchPartnersForDistributionList',
  components: {
    'v-date-picker': DatePicker,
    Multiselect,
    headquartersSelector,
    feeAgreementSelector,
    FeeTypeMultipleSelector,
    commonAgreementSelector,
    PaymentMethodMultipleSelector,
    consignmentTypeSelector,
    periodicityMonthsMultipleSelector,
    CnaeSelector,
    vSelect,
    InfiniteLoading
  },
  data: function () {
    return {
      topmenu: [
        {name: 'Volver', path: '/communications/distribution-list/add', brand: 'fa fa-arrow-left'},
      ],
      title: 'Nueva Búsqueda',
      subtitle: 'Paso 1 de 2',
      entity_url: '/search',
      entityOptions: [
        {value: 'SOCIO_NOSOCIO', text: 'Socio/No Socio'},
        {value: 'CONSULTA', text: 'Consulta'},
        {value: 'REMESA', text: 'Remesa'},
        {value: 'RECIBO', text: 'Recibo'},
        {value: 'DEVOLUCION', text: 'Devolución'},
      ],
      sex: [
        {uuid: 1, name: 'Hombre'},
        {uuid: 2, name: 'Mujer'},
        {uuid: 3, name: 'Otra identidad'},
      ],
      constantFields: ['active','located','periodicity', 'periodicities','paymentMethod', 'paymentMethods','feeType'],
      users: [],
      clients: [],
      commercialUsers: [],
      affiliationUsers: [],
      refundUsers: [],
      categories: [],
      associatedProjects: [],
      advisers: [],
      consignments: [],
      bankReturns: [],
      search_fields: [{
        rows: [{
          field: '',
          childField: '',
          fields: null,
          childFields: null,
          fieldConditions: null,
          fieldCondition: '',
          text1: null,
          text2: null,
          sqlConditions: ''
        }]
      }],
      selectedEntity: 'SOCIO_NOSOCIO',
      selectedChildEntity: [],
      fields: [],
      childFields: [],
      fieldConditions: [],
      fieldsList: [],
      activeGroupIndex: 0,
      activeItemIndex: 0,
      items: [],
      selectedItem: null,
      page: 1,
      perPage: 10,
      search: '',
      observer: null,
      list: [],
      loading: false,
      scrolled: 0,
      selectedCampoEntity:[],
      count: 0,
      total: 0
    }
  },
  mounted() {
    this.$eventHub.$emit('captureMenu', this.topmenu);
    this.requests('users', 'get', 200, 'users');
    this.requests('clients', 'get', 200, 'clients');
    this.requests('consignments', 'get', 200, 'consignments');
    this.requests('bank-returns', 'get', 200, 'bankReturns');
    this.getQueryCategories();
    this.getAdvisers();
    this.getAssociatedProjects();
    this.selectedEntity = 'SOCIO_NOSOCIO';
    this.searchFields('SOCIO_NOSOCIO', null, false);
    document.addEventListener('click', this.handleClickOutsideDropdown);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutsideDropdown);
  },
  computed: {
    ...mapGetters([
      'activeFeeTypes'
    ]),
    memberStatusOptions() {
      return memberStatusOptions;
    },
    memberLocatedOptions() {
      return memberLocatedOptions;
    },
    queryOrigins() {
      return getQueryOriginsOptions();
    },
    periodicityArray() {
      let options = periodicityOptions.slice(0);
      options.unshift({
        key: 'ALL',
        value: 'Todas'
      });

      return options;
    },
    paymentMethodsOptions() {
      let options = paymentMethods.slice(0);
      options.unshift({
        key: 'ALL',
        value: 'Todas'
      });
      return options;
    }
  },
  methods: {
    filterUsers: filterUsers,
    filterActiveStatusUsers: filterActiveStatusUsers,
    addNewRow() {
      this.search_fields.push({
        rows: [{
          field: '',
          childField: '',
          fields: this.fields,
          childFields: null,
          fieldConditions: null,
          fieldCondition: '',
          text1: null,
          text2: null,
          sqlConditions: ''
        }]
      });
      this.activeGroupIndex = this.search_fields.length - 1;
      this.activeItemIndex = 0;
    },
    generateFieldsList() {
      const fieldsList = [];
      this.search_fields.forEach((group) => {
        group.rows.forEach((row) => {
          if (row.field && row.field.row) {
            fieldsList.push({ field: row.field.row });
          }
        });
      });

      return fieldsList;
    },
    async searchFields(value, childEntityValue, childEntity) {
      if(childEntity == true && childEntityValue != null){
        this.selectedChildEntity[childEntityValue.index] = childEntityValue.fieldName;
        let data = await searchFields(childEntityValue.fieldName, 'single');
        this.childFields = data.fields;
        this.search_fields[this.activeGroupIndex].rows[this.activeItemIndex].childFields = data.fields;
      } else {
        this.selectedEntity = value;
        let data = await searchFields(value, 'single');
        this.fields = data.fields;
        this.selectedCampoEntity = data.fields;
        this.search_fields[this.activeGroupIndex].rows[this.activeItemIndex].fields = data.fields;
      }
    },
    async searchFieldConditions(value) {
      this.selectedCampoEntity = value;
      if (value) {
        if(value.fieldDataAttr){
          this.searchFields('', value, true);
        }
        else {
          if (value.fieldDataAttr || (value.fieldType != "DROPDOWN")) {
            let data = await searchFieldConditions(value.fieldType);
            this.$set(this.search_fields[value.parent].rows[value.index], 'fieldConditions', data.filters);
            if (value.row === 'client') {
              this.fetchData('clients');
            }
            if (value.row === 'member') {
              this.fetchData('members');
            }
            if (value.row === 'consignment') {
              this.fetchData('consignments');
            }
            if (value.row === 'bankReturns') {
              this.fetchData('bank-returns');
            }
          }
        }
      }
    },
    addGroupCondition(condition, parent, child) {
      this.$set(this.search_fields[parent].rows[child], 'sqlConditions', condition);
      this.search_fields[parent].rows.push({
        field: '',
        childField: '',
        fields: this.fields,
        childFields: null,
        fieldConditions: null,
        fieldCondition: '',
        text1: null,
        text2: null,
        sqlConditions: ''
      });
      this.activeGroupIndex = this.search_fields.length - 1;
      this.activeItemIndex = this.search_fields[parent].rows.length - 1;
    },
    deleteGroupCondition(parent, child){
      let arr = this.search_fields[parent].rows;
      var no_need_value = child;
      var tmpArray = new Array();
      var index = 0;
      for (var k in arr) {
        if (k != no_need_value) {
          arr[k].field.index = index;
          tmpArray.push(arr[k]);
          index++;
        }
      }
      arr = tmpArray;
      this.search_fields[parent].rows = arr;
    },
    validate() {
      if (this.search_fields && this.search_fields.length) {
        for (let index = 0; index < this.search_fields.length; ++index) {
          const element = this.search_fields[index];
          const validation = this.search_fields[index].rows.every(item => (item.field && item.fieldCondition && item.text1) || (item.field && item.fieldCondition == '' && item.text1) || (item.fieldCondition));
          return validation;
        }
      }
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      } else {
        return null;
      }
    },
    customLabel({firstname, lastname}) {
      return `${firstname} – ${lastname}`;
    },
    categoriesCustom(category) {
      if ('depth' in category && category.depth > 0) {
        return `- ${category.name}`
      } else {
        return `${category.name}`
      }
    },
    customClientLabel({name, surname}) {
      return `${name} – ${surname}`;
    },
    async requests(path, method, okCode, entity) {
      this.$_loadingMixin_showLoading();
      this[entity] = await request(path, method, okCode);
      this.$_loadingMixin_hideLoading();
    },
    async fetchData(entity) {
      this.$refs.multiselect.isOpen = false;
      this.loading = true;
      axios.get(`/${entity}?page=${this.page}&itemsPerPage=${this.perPage}`)
        .then(response => {
          if (entity === 'clients') {
            this.items = [...this.items, ...response.data.clients];
          }
          if (entity === 'members') {
            this.items = [...this.items, ...response.data.members];
          }
          if (entity === 'consignments') {
            this.items = [...this.items, ...response.data.consignments];
          }
          if (entity === 'bank-returns') {
            this.items = [...this.items, ...response.data.bankReturns];
          }
          this.page++;
          this.loading = false;
        });
    },
    handleClickOutsideDropdown(event) {
      if (!this.$el.contains(event.target)) {
      }
    },
    async getAdvisers() {
      await getAdvisers()
        .then((advisers) => {
          this.advisers = advisers;
        })
        .catch(() => {
          this.advisers = [];
        });
    },
    async getQueryCategories() {
      await getQueryCategoriesTree()
        .then((queryCategories) => {
          this.categories = queryCategories
        })
        .catch(() => {
          this.categories = [];
        });
    },
    async getAssociatedProjects() {
      await getAssociatedProjects()
        .then((associatedProjects) => {
          this.associatedProjects = associatedProjects;
        });
    },
    store() {
      this.fieldsList = this.generateFieldsList();
      this.search_fields.forEach((acc, element) => {
        acc.rows.forEach((item, index) => {
          delete acc.rows[index].fieldConditions;
          let include = this.constantFields.includes(acc.rows[index].field.row);
          if (typeof this.search_fields[element].rows[index].text1 === 'object' && include) {
            let text1Data = this.search_fields[element].rows[index].text1;
            if(text1Data != null){
              let values = Object.values(text1Data).map((obj) => {
                if(obj && obj.value){
                  return obj.value;
                } else {
                  return obj;
                }
              });
              this.search_fields[element].rows[index].text1 = values;
            } else {
              this.search_fields[element].rows[index].text1 = null;
            }
          } else if(typeof this.search_fields[element].rows[index].text1 === 'object' && !include) {
            if(this.search_fields[element].rows[index].field.fieldType === "DATE") {
              this.search_fields[element].rows[index].text1 = acc.rows[index].text1;
            } else {
              let text1Object = this.search_fields[element].rows[index].text1;
              if(text1Object != null) {
                let uuidValues = Object.values(text1Object).map((obj) => {
                  if(obj && obj.uuid){
                    return obj.uuid;
                  } else {
                    return obj;
                  }
                });
                this.search_fields[element].rows[index].text1 = uuidValues;
              } else {
                this.search_fields[element].rows[index].text1 = null;
              }
            }
          } else {
            this.search_fields[element].rows[index].text1 = acc.rows[index].text1;
          }
          this.search_fields[element].rows[index].field = acc.rows[index].field.row;
          this.search_fields[element].rows[index].fieldCondition = acc.rows[index].fieldCondition;
          this.search_fields[element].rows[index].sqlConditions = acc.rows[index].sqlConditions;
          this.search_fields[element].rows[index].text2 = acc.rows[index].text2;
        });
      });

      let self = this;
      try {
        self.$_loadingMixin_showLoading();
        self.getSearch(this.search_fields, this.selectedEntity, this.fieldsList);
      } catch (error) {
        self.$_loadingMixin_hideLoading();
      }
    },
    async getSearch(query, entity, fieldsList) {
      try {
        let response = await axios({
          method: 'post',
          url: '/search/distribution/data',
          data: {"entity": entity, "searchData": query, "fields": fieldsList}
        });
        if (response && response.status === 200) {
          const { total, count } = response.data;

          this.count = count;
          this.total = total;

          const totalRecords = this.total;
          const selectedCount = this.count;
          const searchFields = this.search_fields;
          const selectedEntity = this.selectedEntity;
          const fieldsList = this.fieldsList;

          const responseData = {
            totalRecords,
            selectedCount,
            searchFields,
            selectedEntity,
            fieldsList
          };

          await this.$store.dispatch('setSearchMemberResponse', responseData);

          if (this.$route.query.hasOwnProperty('distributionListUUId')){
            await this.$router.push({
              path: '/communications/distribution-list/edit/'+this.$route.query.distributionListUUId
            });
            this.$_loadingMixin_hideLoading();
          }else{
            await this.$router.push({
              path: '/communications/distribution-list/add'
            });
            this.$_loadingMixin_hideLoading();
          }
        }
      } catch (error) {
        this.$_loadingMixin_hideLoading();
      }
    }
  },
  watch: {
    activeGroupIndex(newVal, oldVal) {
    },
    activeItemIndex(newVal, oldVal) {
    }

  }
}
</script>
<style scoped>
.multiselect-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  background-color: #f0f0f0;
  cursor: pointer;
}
.hasChildEntity {
  width: 100%;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}
.hasChildEntity > .form-group {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}
</style>
